import type { LargeMenuOptimizations } from '@/app/[domain]/[lang]/office-catering/vendors/[permalink]/page'
import { getCountryCodeFromName } from '@/helpers/multiRegion/countries'
import { taxAcronym as getTaxAcronym } from '@/helpers/vatRegions'
import { Skeleton } from '@mui/material'

import type React from 'react'

import type { MenuVendor } from '../../domain/menu-vendor'
import { useMenuPageState } from '../../states/menu-page'
import { useVendorLocationData } from '../../store/vendorLocationStore'
import CategoryAccordion from '../menu-display/category-accordion'

export const MenuSection: React.FC<{
  menuState: ReturnType<typeof useMenuPageState>
  vendor: MenuVendor
  largeMenuOptimizations?: LargeMenuOptimizations
}> = ({ menuState, vendor, largeMenuOptimizations }) => {
  const { taxAcronym } = useVendorLocationData()

  const fallbackCountry = vendor.locations?.[0]?.country
  const fallbackTaxAcronym = fallbackCountry
    ? getTaxAcronym(getCountryCodeFromName(fallbackCountry))
    : 'GST'

  if (menuState.type === 'loading') {
    return <Skeleton height={400} />
  }

  return (
    <CategoryAccordion
      menuItemsState={menuState}
      vendor={vendor}
      taxAcronym={taxAcronym ?? fallbackTaxAcronym}
      largeMenuOptimizations={largeMenuOptimizations}
    />
  )
}
